import React from "react";
import { object, array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Organism1 from "./Organism1";
import Organism2 from "./Organism2";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";

import { getSlug } from "../../utils/utils";

import "./twelveStoryOneAdsOneWidget.m.css";

const TwelveStoryOneAdsOneWidget = ({ collection, sections, domainSlug }) => {
  if (!(collection && collection.items && collection.items.length)) {
    return null;
  }

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const collectionSlug = getSlug(collection, sections, domainSlug);

  return (
    <div styleName="base" className="twelve-story-oneads-onewidget">
      {showCollectionName && (
        <CollectionTitleWithArrow
          collectionName={collection.name}
          collectionSlug={collectionSlug}
          headlineClassName="collection-name-arrow"
          updatedFont={true}
        />
      )}
      <div styleName="wrapper">
        <Organism1 collection={collection} captionStyle="default" />
        <Organism2 collection={collection} />
      </div>
    </div>
  );
};

TwelveStoryOneAdsOneWidget.propTypes = {
  collection: object,
  sections: array,
  domainSlug: string
};

const mapStateToProps = state => ({
  sections: get(state, ["qt", "config", "sections"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], "")
});

export default connect(mapStateToProps, null)(TwelveStoryOneAdsOneWidget);
